import { CommonModule, DOCUMENT } from '@angular/common';
import { Component, Inject, inject } from '@angular/core';
import {
  collection,
  collectionData,
  doc,
  docData,
  Firestore,
  query,
  where,
} from '@angular/fire/firestore';
import { forkJoin, map, Observable, of, switchMap, take } from 'rxjs';
import { CompanyCardComponent } from '../../components/company-card/company-card.component';
import { Meta, Title } from '@angular/platform-browser';

@Component({
  selector: 'app-companies',
  imports: [CommonModule, CompanyCardComponent],
  templateUrl: './companies.component.html',
  styleUrl: './companies.component.css',
})
export class CompaniesComponent {
  firestore = inject(Firestore);
  companies$: Observable<any[]> | null = null;

  constructor(
    private meta: Meta,
    private title: Title,
    @Inject(DOCUMENT) private document: Document
  ) {
    this.companies$ = collectionData(
      query(
        collection(this.firestore, 'usernames'),
        where('isList', '==', true)
      ),
      {
        idField: 'id',
      }
    );

    this.companies$.subscribe((data) => {
      if (data) this.updatePageMeta(data);
    });
  }
  // Step 1: Fetch all tenants

  // companies$: Observable<any[]> = this.tenants$.pipe(
  //   switchMap((tenants) => {
  //     if (!tenants || tenants.length === 0) {
  //       return of([]);
  //     }
  //     const accessObservables = tenants.map((tenant) =>
  //       docData<any>(
  //         doc(this.firestore, `tenants/${tenant.id}/access/public`)
  //       ).pipe(
  //         take(1),
  //         map((publicData) => ({
  //           tenantId: tenant.id,
  //           ...publicData,
  //         }))
  //       )
  //     );

  //     return forkJoin(accessObservables);
  //   })
  // );

  ngOnInit(): void {}

  updatePageMeta(data: any): void {
    const pageTitle = `Top Maritime Companies Hiring Seafarers | VoyageX Jobs`;
    const pageDescription = `Find the best maritime companies hiring seafarers for cargo ships, tankers, offshore vessels, and cruise lines. Apply for high-paying ship jobs in the merchant navy and offshore industry.`;

    this.title.setTitle(pageTitle);

    // <meta name="robots" content="noindex, nofollow, noarchive">
    this.meta.updateTag({
      name: 'robots',
      content: 'index, follow, archive',
    });

    this.meta.updateTag({ name: 'description', content: pageDescription });
    this.meta.updateTag({
      name: 'keywords',
      content: `seafarer jobs, maritime job vacancies, shipping companies hiring, offshore jobs, crew jobs on ships, merchant navy jobs`,
    });
    this.meta.updateTag({ property: 'og:title', content: pageTitle });
    this.meta.updateTag({
      property: 'og:description',
      content: pageDescription,
    });
    this.meta.updateTag({
      property: 'og:url',
      content: `https://jobs.voyagex.ai/companies`,
    });
    this.meta.updateTag({
      property: 'og:image',
      content: data?.photoUrl || 'assets/icon_1024.png',
    });
    this.meta.updateTag({ name: 'twitter:title', content: pageTitle });
    this.meta.updateTag({
      name: 'twitter:description',
      content: pageDescription,
    });
    this.meta.updateTag({
      name: 'twitter:image',
      content: data?.photoUrl || 'assets/icon_1024.png',
    });

    // let links = this.doc.getElementsByTagName('link');
    // links[0].setAttribute('href', `https://homofer.com${this.path}/`);

    const canonicalLink: HTMLLinkElement =
      this.document.querySelector("link[rel='canonical']") ||
      this.document.createElement('link');
    canonicalLink.setAttribute('rel', 'canonical');
    canonicalLink.setAttribute('href', `https://jobs.voyagex.ai/companies`);

    if (!this.document.head.contains(canonicalLink)) {
      this.document.head.appendChild(canonicalLink);
    }
  }
}
